export const GET_ADDRESS_MAPS_URL = "https://nominatim.openstreetmap.org/reverse";
export const SEARCH_ADDRESS_MAPS_URL = "https://nominatim.openstreetmap.org/search";